import {
  authFetch,
  API_BASE_URL,
} from '@/lib/api-client';
import {
  stockLevelsResponseSchema,
  type StockLevelsResponse,
  type StockFilters,
} from '../types';

/**
 * Fetch stock levels for a site with optional filters.
 */
export async function getStockLevels(
  siteId: string,
  filters?: StockFilters
): Promise<StockLevelsResponse> {
  const params = new URLSearchParams();

  if (filters?.storageLocationId) {
    params.set('storageLocationId', filters.storageLocationId);
  }
  if (filters?.category) {
    params.set('category', filters.category);
  }
  if (filters?.lowStockOnly) {
    params.set('lowStockOnly', 'true');
  }

  const queryString = params.toString();
  const basePath = `${API_BASE_URL}/v1/sites/${siteId}/inventory`;
  const url = queryString ? `${basePath}?${queryString}` : basePath;

  const response = await authFetch(url);

  if (!response.ok) {
    throw new ApiClientError(
      response.status,
      `Failed to fetch stock levels: ${response.statusText}`
    );
  }

  const data: unknown = await response.json();
  return stockLevelsResponseSchema.parse(data);
}

/**
 * Custom error class for API client errors.
 */
export class ApiClientError extends Error {
  constructor(
    public readonly statusCode: number,
    message: string
  ) {
    super(message);
    this.name = 'ApiClientError';
  }
}
